import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Philosophy } from './components/Philosophy';
import { Occasions } from './components/Occasions';
import { Categories } from './components/Categories';
import { Businesses } from './components/Businesses';
import { Tonality } from './components/Tonality';
import { Vision } from './components/Vision';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-warm text-brun" data-id="element-0" data-mp="2mm2m8fvmev3y">
      <Navbar data-id="element-1" data-mp="2mndq0fp2g2v2" />
      <main data-id="element-2" data-mp="2mnnge4e0wc1a">
        <Hero data-id="element-3" data-mp="2mjzlp1wudjkz" />
        <Philosophy data-id="element-4" data-mp="31aqh0jxn70su" />
        <Occasions data-id="element-5" data-mp="31ayr642drs0c" />
        <Categories data-id="element-6" data-mp="31bi9hlvy0iew" />
        <Businesses data-id="element-7" data-mp="31c1iue7j1yhb" />
        <Tonality data-id="element-8" data-mp="2wk09p15nonvi" />
        <Vision data-id="element-9" data-mp="2wjgqzi86lvgf" />
      </main>
      <Footer data-id="element-10" data-mp="2wj8dpp85co4p" />
    </div>;
}